var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDocs = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 256,
  height: 44,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "square",
  strokeWidth: 2.5,
  clipPath: "url(#svg-public/img/unlimited-docs/banner/docs.svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M120.5 36.199c42.11-4.385 108 .069 108 .069M238.239 17.087c1.743-.97 5.47-3.211 7.748-4.478M240.918 23.394l5.411.476M233.087 12.506l.8-5.373"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "svg-public/img/unlimited-docs/banner/docs.svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h256v44H0z"
})))));
export { SvgDocs as ReactComponent };